const content = {
  facility: {
    heading: 'Facility Information',
    // Rendered as: "If this facility address is not where your loved resides, please [click here] to contact us."
    descriptionBefore: 'If this facility address is not where your loved resides, please ',
    descriptionLink: 'click here',
    descriptionAfter: ' to contact us.',
    labels: {
      name: 'Facility Name',
      providerNumber: 'Provider #',
      address: 'Address',
    },
  },
  patient: {
    heading: 'Patient Information',
    description: 'Enter the patient\u2019s information exactly as it should appear on the consent.',
    labels: {
      firstName: 'First Name',
      lastName: 'Last Name',
      dateOfBirth: 'Date of Birth',
    },
  },
  completedBy: {
    heading: 'Who is completing this?',
    description: 'Choose whether the patient is signing or a Proxy/Designee is signing on the patient\u2019s behalf.',
    options: {
      patient: 'The patient is completing this consent for themselves',
      proxy: 'A Proxy/Designee is completing this consent on the patient\u2019s behalf',
    },
    proxyLabels: {
      firstName: 'Proxy/Designee First Name',
      lastName: 'Proxy/Designee Last Name',
      email: 'Proxy/Designee Email',
      phone: 'Proxy/Designee Phone',
      relationship: 'Relationship',
    },
  },
  consentChoice: {
    // On the live site this sentence is the (uppercase) heading of the group; there is no extra description.
    heading: 'Choose whether the patient is opting in or opting out of services.',
    /** Accessible name of the radio group (the visible label on the WordPress form is hidden) */
    legend: 'Consent choice',
    options: { opt_in: 'Opt In', opt_out: 'Opt Out' },
  },
  agreement: {
    heading: 'Consent Agreement',
    intro:
      'Your facility has contracted with TapestryHealth\u2122 to provide Communication Technology-Based Services (CTBS), such as Chronic Care Management Services (CCM), Remote Physiologic Monitoring (RPM), and/or Behavioral Health Integration (BHI) to residents. These services provide clinical information and insights to help your care team. It is important that you understand:',
    understand: [
      'Only one practitioner can provide you with similar CTBS services at a time.',
      'This does not replace your relationship with your primary care provider or other specialists.',
      'You can stop these services at any time.',
      'Cost sharing, such as co-pays or deductibles, is possible depending upon your insurance.',
    ],
    bySigning: 'By signing this document,',
    acknowledgements: [
      'I consent to allowing TapestryHealth\u2122 to provide monthly services offered by this facility, which may include Chronic Care Management Services (CCM), Remote Physiologic Monitoring (RPM), and/or Behavioral Health Integration (BHI).',
      'I acknowledge that only one provider can furnish and bill for TapestryHealth\u2122 services for me during a calendar month. I will tell you if I enter into a similar agreement with another practice.',
      'I understand that I may receive an Explanation of Benefits (EOB) from my insurance and/or a statement from TapestryHealth\u2122 for co-pays or co-insurance for these services. The EOB and statements will show Tapestry Telehealth and/or Chess Medicine as the provider. I may be billed for these services up to once a month.',
      'I understand services rendered are dependent on my insurance coverage and any co-pays or co-insurance are determined by my insurance provider.',
      'I consent to electronic communication of my health information with other health care providers involved in my care as allowed by state and local rules and regulations.',
    ],
    rightsHeading: 'Your Rights',
    rights: [
      'As part of these services, a copy of your comprehensive plan of care is accessible electronically and provided to your caregivers.',
      // The email in this item is rendered as a mailto link by the component.
      'You have the right to stop Chronic Care Management Services (CCM), Remote Physiologic Monitoring (RPM), and/or Behavioral Health Integration (BHI) services at any time, effective at the end of a calendar month. You can opt out of these services at any time by emailing TapestryHealth\u2122\u2019s care management team at ',
    ],
    rightsEmail: 'consent@tapestryhealth.com',
    downloadPdf: 'Download consent details (PDF)',
  },
  beforeYouSign: {
    heading: 'Before you sign',
    lead: 'TapestryHealth\u2122 provides Communication Technology-Based Services such as Chronic Care Management, Remote Physiologic Monitoring and/or Behavioral Health Integration.',
    body: 'These services support your care team by helping identify changes in health earlier. They do not replace your relationship with your primary care provider or specialists. Only one practitioner can provide CTBS services at a time, you may opt out at any time, and depending on insurance, cost-sharing may apply.',
    educationalMaterial: 'Educational Material',
    privacyPractices: 'Privacy Practices',
  },
  signature: {
    heading: 'Authorization Signature',
    clear: 'Clear signature',
  },
  copyEmail: {
    label: 'Enter your email to receive a copy of this form',
    description: '(Optional) Enter your email to receive a copy of this signed consent form, or download it directly ',
    downloadLink: 'here',
  },
  submit: {
    button: 'Confirm & Sign',
    submitting: 'Submitting\u2026',
    note: 'By clicking \u201CConfirm & Sign,\u201D you authorize TapestryHealth\u2122 to provide monitoring services as described above.',
  },
  emailForm: {
    prompt: 'Would you prefer we email you this form?',
    link: 'Submit your email here.',
    label: 'Email Address',
    placeholder: 'you@example.com',
    button: 'Submit',
    /** Shown after a successful submit. Not on the WordPress site — set it to whatever the client confirms. */
    sent: 'Thank you.',
  },
  contactRequest: {
    title: 'Have a specialist contact me',
    /** Popup opened from "click here" in Facility Information */
    facilityIntro: 'Share your contact details and a TapestryHealth\u2122 team member will contact you.',
    /** Popup opened from "Please contact me first" on the page */
    generalIntro:
      'If you have questions about this service, share your contact details and a TapestryHealth\u2122 team member will reach out to you via email and review the monitoring program.',
    labels: {
      facilityName: 'Facility name',
      providerNumber: 'Provider #',
      facilityAddress: 'Facility address',
      name: 'Your name',
      phone: 'Best phone number',
      email: 'Email',
      bestTime: 'Best time to reach you',
      questions: 'Questions or concerns',
    },
    placeholders: {
      facilityName: 'Facility name',
      providerNumber: 'Provider',
      facilityAddress: 'Address',
      name: 'Name',
      phone: 'Phone number',
      email: 'Email',
      bestTime: 'Select time',
      questions: 'Questions or concerns',
    },
    bestTimeOptions: ['Morning', 'Afternoon', 'Evening'],
    button: 'Request a call',
    submitting: 'Sending\u2026',
    /** Not on the WordPress site — set it to whatever the client confirms. */
    sent: 'Thank you. A TapestryHealth\u2122 team member will be in touch.',
  },
  errors: {
    required: 'This field is required.',
    email: 'Please enter a valid email address.',
    phone: 'Please enter a valid phone number.',
    date: 'Please enter a valid date.',
    signature: 'Please sign in the box above.',
    submitFailed: 'Something went wrong while submitting. Please try again.',
  },
  thankYou: {
    approvedHeading: 'Thank you \u2013 monitoring has been authorized',
    declinedHeading: 'Thank you \u2013 your response has been recorded',
    /** `{patient}` and `{facility}` are replaced */
    approvedIntro:
      'We\u2019ve received your consent for TapestryHealth\u2122 to provide ongoing monitoring and care management services for {patient} at {facility}.',
    declinedIntro:
      'We\u2019ve recorded that advanced support services have been declined for {patient} at {facility}. No monitoring services will be started.',
    approvedBody:
      'The facility and TapestryHealth\u2122 teams will begin monitoring as soon as the program is activated. You may see these services listed on insurance statements as Chronic Care Management (CCM), Remote Physiologic Monitoring (RPM), and/or Behavioral Health Integration (BHI).',
    nextStepsHeading: 'Next steps',
    nextSteps: [
      'If our clinicians see worrisome changes, they may contact the facility.',
      'You can ask the facility staff about \u2018TapestryHealth\u2122 monitoring\u2019 at any time if you have questions.',
      'To stop these services in the future, contact the facility or TapestryHealth\u2122; your choice will take effect at the end of the calendar month.',
    ],
    questions: 'Questions about this program? Email ',
    email: 'consent@tapestryhealth.com',
    orCall: ' or call ',
    phone: '(203) 666-8145',
    phoneHref: 'tel:2036668145',
  },
};
export { content };
